import React from "react";
import { IoReceipt } from "react-icons/io5";
import { IoGift } from "react-icons/io5";
import { BiSolidTimer } from "react-icons/bi";
import { FaQuestion } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaHistory } from "react-icons/fa";
import clsx from "clsx";

interface GridMenuProps {
  pendingCount: number;
  confirmedCount: number;
  handleOpenBottomSheet: () => void;
}

const GridMenu: React.FC<GridMenuProps> = ({
  pendingCount,
  confirmedCount,
  handleOpenBottomSheet,
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-md pb-10">
      <section className="grid grid-cols-2 gap-6 w-full max-w-md">
        {/* 랜덤팩 픽업 */}
        <button
          onClick={() => navigate("/boss/pre-order/sales")}
          className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center relative space-y-2"
        >
          <IoReceipt className="w-8 h-8 text-blue-400" />
          <span className="text-lg text-green-600 font-semibold">
            주문 현황
          </span>
          <div className={clsx("flex items-center justify-center gap-2")}>
            <div
              className={clsx(
                "text-md px-2 py-1 rounded-md",
                pendingCount > 0
                  ? "bg-red-100 text-red-500 border border-red-500"
                  : "bg-gray-100 text-gray-500 border border-gray-300",
                pendingCount > 0 && "animate-pulse"
              )}
            >
              <span className="text-sm">확인 필요: </span>
              <span className="font-black">{pendingCount}</span>
            </div>
            <div
              className={clsx(
                "text-md px-2 py-1 rounded-md",
                confirmedCount > 0
                  ? "bg-green-100 text-green-600 border border-green-500"
                  : "bg-gray-100 text-gray-500 border border-gray-300",
                confirmedCount > 0 && "animate-pulse"
              )}
            >
              <span className="text-sm">확정: </span>
              <span className="font-black">{confirmedCount}</span>
            </div>
          </div>
        </button>

        {/* 랜덤팩 관리 */}
        <div className="w-full h-full">
          <button
            onClick={() => {
              navigate("/boss/pre-order/pack-management");
            }}
            className="w-full bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
          >
            <IoGift className="w-8 h-8 text-blue-400" />
            <span className="text-lg text-green-600 font-semibold">
              판매 설정
              <br />( 가격/개수 )
            </span>
          </button>
        </div>

        {/* 픽업시간 설정 */}
        <div className="w-full h-full">
          <button
            onClick={() => {
              navigate("/boss/pre-order/pickup-time-update");
            }}
            className="w-full bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
          >
            <BiSolidTimer className="w-8 h-8 text-blue-400" />
            <span className="text-lg text-green-600 font-semibold">
              오픈 설정
              <br />( 매장 열기/닫기 )
            </span>
          </button>
        </div>

        {/* 픽업시간 설정 */}
        <div className="w-full h-full">
          <button
            onClick={() => {
              navigate("/boss/pre-order/previous-sales");
            }}
            className="w-full py-7 bg-white text-[#444] rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
          >
            <FaHistory className="w-8 h-8 text-blue-400" />
            <span className="text-lg text-green-600 font-semibold">
              이전 주문
              <br />
            </span>
          </button>
        </div>

        {/* 예약 판매 안내 */}
        <div className="w-full h-full">
          <button
            onClick={handleOpenBottomSheet}
            className="w-full bg-green-500 text-[#444] py-6 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
          >
            <FaQuestion className="w-8 h-8 text-white" />
            <span className="text-lg text-white font-semibold">
              예약 판매가 뭔가요?
            </span>
          </button>
        </div>
      </section>
    </div>
  );
};

export default GridMenu;
